export default __webpack_public_path__ + "static/media/foodCourt.9e9b227b.svg";